module.exports = __webpack_public_path__ + "static/contactMe-4c1beeda74c3fcf6c1fa24b685174a2e.png";